import React, { useState } from "react";
import { Button, Input, Modal, ModalBody, ModalHeader } from "reactstrap";
import { REGEX } from "constants/CommonConstants";

function AddNewCityModal(props) {
  const [cityError, setCityError] = useState("");

  const handleCityChange = (e) => {
    props.setCityName(e.target.value);

    // Clear error while typing
    if (cityError) {
      setCityError("");
    }
  };
  const handleCancel = () => {
    props.setCityName("");
    setCityError("");
    props.onCancel();
  };
  const handleCityBlur = (e) => {
    const value = e.target.value.trim();
    if (value && !REGEX.CITY_REGEX.test(value)) {
      setCityError("City name can contain only alphabets and spaces.");
    } else {
      setCityError("");
    }
  };

  return (
    <Modal isOpen={props.isOpen} toggle={handleCancel} centered>
      <ModalHeader toggle={handleCancel}>Add New City</ModalHeader>
      <ModalBody>
        <div className="mb-4">
          <span>
            Add a new city for state: <strong> {props?.stateName}</strong>
          </span>
        </div>

        <Input
          type="text"
          placeholder="Enter city name"
          value={props.cityName}
          onChange={handleCityChange}
          onBlur={handleCityBlur}
          className={cityError ? "is-invalid" : ""}
        />
        {cityError && (
          <small className="invalid-feedback d-block">{cityError}</small>
        )}
        <div className="d-flex justify-content-end mt-5">
          <Button
            color="primary"
            className="btn-deep-blue mr-2 px-4 py-2"
            type="button"
            disabled={!!cityError}
            onClick={() => props.onSave(props.stateID)}
          >
            {props.showLoader ? (
              <i className="fa fa-spinner fa-spin mr-2"></i>
            ) : (
              "Save"
            )}
          </Button>
        </div>
      </ModalBody>
    </Modal>
  );
}

export default AddNewCityModal;
